<template>

  <form class="mt-2" id="form-modal" @submit.prevent="submitForm">
    <div class="col-md-12 px-0">
      <div>
        <div class="form-group">
          <label class="form-label">Title<span class="required text-danger">*</span>:</label>
          <input type="text" v-model="task.title" class="form-control" placeholder="Title"/>
        </div>

        <div class="form-group">
          <label class="form-label">Description<span class="required text-danger">*</span>:</label>
          <div class="text_editor">
            <tiny-mce-editor :vModelName.sync="task.description"></tiny-mce-editor><br />
          </div>
        </div>

        <div class="form-group">
          <label class="form-label">Due Date<span class="required text-danger">*</span>:</label>
          <input type="datetime-local" v-model="task.due_date" class="form-control" placeholder="Due Date"/>
        </div>

        <div class="form-group">
          <label class="form-label">Assign To<span class="required text-danger">*</span>:</label>
          <multiselect :options="assignTo" :allow-empty="true" :searchable="true" :multiple="false"
                       :selectedLabel="null" :deselectLabel="null" :selectLabel="null"
                       label="user_name" track-by="id" v-model="task.assigned_to_selected" :loading="loading">
          </multiselect>
        </div>
      </div>

      <div class="text-right">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" >
          Close
        </button>
        <button type="submit" class="btn btn-default ml-1">
          <font-awesome-icon
              v-if="mini_loading"
              icon="spinner"
              style="animation: spin 2s linear infinite; float:right; margin-left: 5px; margin-top: 3px;"
          />
          
          {{ action !== 'edit' ? "Save" : "Update" }}
        </button>
      </div>
    </div>
  </form>
</template>

<script>
import Multiselect from "vue-multiselect";
import moment from "moment";
import TinymceEditor from "@/views/partials/tiny_mce_editor.vue";
export default {
  components: {Multiselect,"tiny-mce-editor": TinymceEditor},
  props: ['formData', 'action', 'testData'],
  data() {
    return {
      task: {
        id: '',
        title: '',
        description: '',
        due_date: '',
        assigned_to: '',
        assigned_to_selected: null,
        product_id: ''
      },
      mini_loading: false,
      assignToUsers: [],
      organizations: [],
      role: JSON.parse(localStorage.getItem("role")),
      loading: false
    };
  },
  computed: {
    assignTo() {
      return this.$store.getters['users/assignToUser'];
    }
  },

  mounted() {
    this.$store.dispatch('users/assignToUser');
    this.onLoadComponent();
  },
  watch: {
    'formData.task.due_date': function (newVal) {
      if (newVal && this.action === 'edit') {
        this.task.due_date = moment(newVal).format("YYYY-MM-DD");
      }
    },
    'formData.task.assigned_to': function (newVal) {
      if (newVal && this.action === 'edit') {
        this.task.assigned_to_selected = {
          user_name: newVal.user_name,
          id: newVal.id
        };
      }
    },
    formData: {
      handler(newVal) {
        this.onLoadComponent();
      },
      deep: true, // Enables deep watching of the object properties
    },
  },
  methods: {
    onLoadComponent() {
      if (this.action === 'edit' && this.formData.task) {
        this.task.id = this.formData.task.id;
        this.task.title = this.formData.task.title;
        this.task.description = this.formData.task.description;
        this.task.due_date = moment(
            `${this.formData.task.due_date} ${this.formData.task.time}`
        ).format("YYYY-MM-DD HH:mm");

        this.task.assigned_to = this.formData.task.assigned_to;
        this.task.assigned_to_selected = this.formData.task.assigned_to ? {
          user_name: this.formData.task.assigned_to.user_name,
          id: this.formData.task.assigned_to.id
        } : null;
      } else if (this.action === "add") {
        this.task.due_date = moment(`${this.formData.task.due_date} ${this.formData.task.due_date}`, "YYYY-MM-DD HH:mm").format("YYYY-MM-DDTHH:mm");
      }
    },
    validateForm() {
      if (!this.task.title || !this.task.description || !this.task.assigned_to_selected || !this.task.due_date) {
        this.$toast.error('Please fill in the required fields.');
        return false;
      }
      return true;
    },
    resetForm() {
      this.task = {
        id: null,
        title: '',
        due_date: '',
        assigned_to_selected: null,
      };
    },
    submitForm() {
      if (!this.validateForm()) return;
      this.mini_loading = true;
      const method = this.action === 'edit' ? 'update' : 'add';
      this.task.assigned_to = this.task.assigned_to_selected.id;

      this.$store.dispatch(`quick_task/${method}`, this.task)
          .then((response) => {
            this.mini_loading = false;
            if (response && response.error) {
              this.$toast.error(response.error);
            } else {

              if (method === 'update'){
                this.$toast.success('Task updated successfully.');
              }else {
                this.$toast.success('Task saved successfully.');
              }
              
              window.$('#modal').modal('hide');
              this.resetForm();
              this.refreshTasks();
            }
          })
          .catch(() => {
            this.mini_loading = false;
            this.$toast.error('An error occurred while saving the task.');
          });
    },
    refreshTasks() {
      const status = localStorage.getItem('quickTaskTab');
      const page = this.$store.getters['quick_task/currentPage'];
      const filters =  this.$store.getters['quick_task/filters'];
      // const type = this.type === "myTask" ? 0 : 1;
      this.$store.dispatch("quick_task/getAllTask", [page,status,'',filters,0]);
    }
  }
};
</script>

